import { Component, OnInit, ElementRef, Renderer2, DoCheck, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisComponentRegistryServiceInitilizer } from '../../../dynamicform/service/his-component-registry-initializer.service';

import { HTTPStatus } from '../loader/his-httplistener.service';
import { HisBaseGlobalsService } from '../../service/base/his-base-globals.service';
import { HisBootstrapService } from '../../service/base/his-bootstrap.service';

/**
 * a HISinOne page frame with header and footer.
 */
@Component( {
    selector: 'his-page',
    templateUrl: './his-page.component.html',
    styleUrls: ['./his-page.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisPageComponent implements OnInit, DoCheck {
    hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisBootstrapService = inject(HisBootstrapService);
    private hisComponentRegistryServiceInitilizer = inject(HisComponentRegistryServiceInitilizer);
    private elementRef = inject(ElementRef);
    private renderer = inject(Renderer2);
    private httpStatus = inject(HTTPStatus);

    public booted: Promise<boolean>;
    public isMobile: boolean;

    opened = false;
    menuButtonText = 'de.his.portal.navieinblenden';

    focusTitle: HTMLDivElement;

    title: string;
    timeout: any;

    isMouseover: boolean;

    private checkCount = 0;
    private checkTimer: any = null;

    ngOnInit() {
        console.log( 'HisPageComponent: booting...' );
        this.booted = this.hisBootstrapService.boot();
        this.booted.then( () => {
            this.hisComponentRegistryServiceInitilizer.registerStandardComponents();
            this.isMobile = this.hisBaseGlobalsService.getCurrentDevice() === 'mobile';
        } );
        this.setMenu( false );

        this.httpStatus.getHttpStatus().subscribe( ( loading: boolean ) => {
            if ( !loading && !this.isMobile ) {
                this.getFocusTitleElements();
            }
        } );

    }

    ngDoCheck() {
        // this.checkCount++;
        // if ( !this.checkTimer ) {
        //     this.checkTimer = setTimeout( () => {
        //         console.log( `ngDoCheck: ${this.checkCount}x/s` );
        //         this.checkCount = 0;
        //         this.checkTimer = null;
        //     }, 1000 );
        // }
        if ( !this.isMobile ) {
            this.getFocusTitleElements();
        }
    }

    getFocusTitleElements() {
        let all = this.elementRef.nativeElement.querySelectorAll( 'button:not(.note-editable *), a:not(.p-tabview-nav-link, .p-menuitem-link, .note-editable *), inlineicon:not(a *), .textTooltip, span[title], p-sorticon[title], p-treetablesorticon[title], p-autocomplete[title]' );
        //console.log( [...all].filter( el => el.closest( '.note-editable' ) ) );
        for ( const element of all ) {
            if ( element.getAttribute( 'focusTitle' ) !== 'true' ) {
                element.addEventListener( 'keyup', this.onKeyup.bind( this ) );
                element.addEventListener( 'focusout', this.onFocusout.bind( this ) );
                element.addEventListener( 'focus', this.onFocus.bind( this ) );
                element.addEventListener( 'mouseenter', this.onMouseenter.bind( this ) );
                element.addEventListener( 'mouseleave', this.onMouseleave.bind( this ) );
                element.addEventListener( 'click', this.onClickElement.bind( this ) );
            }
            element.setAttribute( 'focusTitle', 'true' );
        }
    }

    onScroll( event: any ) {
        if ( this.focusTitle != null ) {
            this.renderer.removeChild( document.body, this.focusTitle );
            this.focusTitle = null;
        }
    }

    onClickElement( event: any ) {
        let focusTooltips = document.querySelectorAll( '.focusTooltip' );
        if ( focusTooltips.length > 0 ) {
            focusTooltips.forEach( focusTooltip => {
                this.renderer.removeChild( document.body, focusTooltip );
            } );
        }
        
        if ( event.clientX !== 0 && event.clientY !== 0 ) {
            let element = event.currentTarget; // From MDN: currentTarget always refers to the element to which the event handler has been attached, as opposed to Event.target, which identifies the element on which the event occurred and which may be its descendant. E.g. a <g> inside a svg in a button.         
            let newTitle = element.title;
            if ( !newTitle || newTitle?.trim?.().length === 0 ) {
                if ( element.getAttribute( 'data-title' ) && element.getAttribute( 'data-title' ).length !== 0 ) {
                    newTitle = element.getAttribute( 'data-title' );
                }
            }

            // check if element is treeTableToggler in dialog and bind listeners #312308
            if ( this.isTreeTabelTogglerInDialog( element ) ) {
                this.rebindListenersInDialog();
            }
            
            // check if element still exists, needs timeout to wait for overlays to close or open for example
            // todo: find better solution
            setTimeout( () => {
                if ( document.body.contains( element ) ) {
                    // only need to update tooltip if mouse is still over the element
                    if ( this.isMouseover && newTitle && newTitle.trim?.().length !== 0 ) {
                        this.setCustomTooltip( event, element, newTitle );
                    }
                }
            }, 200 );
            
        } else {
            // event.clientX or Y might be zero if treetable is in dialog and navigated by tabs #312308
            // make sure event.target is treeTableToggler in dialog and bind listeners
            if ( this.isTreeTabelTogglerInDialog( event.target ) ) {
                this.rebindListenersInDialog();
            }
        }
    }

    onMouseenter( event: any ) {
        this.isMouseover = true;
        let element = event.target;
        this.title = element.title;

        if ( this.title?.trim().length !== 0 ) {
            this.setCustomTooltip( event, element );
        }
    }

    onMouseleave( event: any ) {
        this.isMouseover = false;
        let element = event.target;
        if ( element.getAttribute( 'data-title' ) && element.getAttribute( 'data-title' ).length !== 0 ) {
            this.renderer.setAttribute( element, 'title', element.getAttribute( 'data-title' ) );
            this.renderer.removeAttribute( element, 'data-title' );
        }

        let focusTooltips = document.querySelectorAll( '.focusTooltip' );
        focusTooltips.forEach( focusTooltip => {
            this.renderer.removeChild( document.body, focusTooltip );
        } );
        clearTimeout( this.timeout );
    }

    onKeyup( event: any ) {
        const code = event.keyCode || event.which;
        const element = event.target;
        const title = element.title;
        if ( code === 27 ) {
            if ( title && title.length !== 0 ) {
                if ( this.focusTitle != null ) {
                    this.renderer.removeChild( document.body, this.focusTitle );
                    this.focusTitle = null;
                    window.removeEventListener( 'scroll', this.onScroll.bind( this ) );
                }
            }
        } else if ( code === 13 || code === 32 ) {
            if ( /Edg/.test( navigator.userAgent ) ) {
                console.log( 'no focus tooltip for edge' );
                return;
            }
            // necessary for p-panel for example #312308
            if ( title && title.length !== 0 ) {
                this.setCustomTooltip( event, element, title );
                window.removeEventListener( 'scroll', this.onScroll.bind( this ) );
            }
        }
    }

    onFocus( event: any ) {
        if ( /Edg/.test( navigator.userAgent ) ) {
            console.log( 'no focus tooltip for edge' );
            return;
        }
        //treeTable fix for #312308
        const element = event.target;
        if ( element.title && element.title.length !== 0 ) {
            this.setCustomTooltip( event, element, element.title, true );
            window.removeEventListener( 'scroll', this.onScroll.bind( this ) );
        }
    }

    onFocusout( event: any ) {
        const element = event.target;
        // check for mouseover, fix for #323758#c2
        if ( this.focusTitle != null && !this.isMouseover ) {
            // re-add title attribute, fix for #312308
            if ( element.title.length === 0 && element.getAttribute( 'data-title' ) && element.getAttribute( 'data-title' ).length !== 0 ) {
                this.renderer.setAttribute( element, 'title', element.getAttribute( 'data-title' ) );
                this.renderer.removeAttribute( element, 'data-title' );
            }
            // remove all currently open tooltips 
            let focusTooltips = document.querySelectorAll( '.focusTooltip' );
            focusTooltips.forEach( focusTooltip => {
                this.renderer.removeChild( document.body, focusTooltip );
            } );
            this.focusTitle = null;
            window.removeEventListener( 'scroll', this.onScroll.bind( this ) );
        }
    }

    setCustomTooltip( event: any, element: any, newTitle?: any, keepTitle?: boolean ) {
        // remove all currently open tooltips before set new one
        let focusTooltips = document.querySelectorAll( '.focusTooltip' );
        focusTooltips.forEach( focusTooltip => {
            this.renderer.removeChild( document.body, focusTooltip );
        } );
        
        // remove title attr to prevent opening browser tooltip, but keep it for seleniumtests and onFocus (fix for #318853)
        if ( this.isMouseover && keepTitle != true && navigator.webdriver != true ) this.renderer.removeAttribute( element, 'title' );
        this.focusTitle = this.renderer.createElement( 'div' );
        let text = this.renderer.createText( this.title );
        if ( newTitle ) {
            text = this.renderer.createText( newTitle );
            this.title = newTitle;
        }
        // fallback for navigation with tabs to be able to re-add the title after on focus out
        this.renderer.setAttribute( element, 'data-title', this.title );

        this.renderer.appendChild( document.body, this.focusTitle );
        this.renderer.appendChild( this.focusTitle, text );
        this.renderer.addClass( this.focusTitle, 'focusTooltip' );

        const rect = element.getBoundingClientRect();
        this.renderer.setStyle( this.focusTitle, 'left', ( event.clientX || rect.left ) + 'px' );
        this.renderer.setStyle( this.focusTitle, 'top', rect.top + element.offsetHeight + 'px' );

        if ( rect.bottom + this.focusTitle.offsetHeight + element.offsetHeight > ( window.innerHeight || document.documentElement.clientHeight ) ) {
            this.renderer.setStyle( this.focusTitle, 'top', rect.top - this.focusTitle.offsetHeight + 'px' );

        }

        const rightPosition = this.focusTitle.offsetWidth + rect.left;
        const winWidth = window.innerWidth;
        const newLeftPosition = rect.left - ( rightPosition - winWidth ) - 20;

        if ( rightPosition >= winWidth ) {
            this.renderer.setStyle( this.focusTitle, 'left', newLeftPosition + 'px' );
        }
    }

    toggleSidebar() {
        this.setMenu( !this.opened );
    }

    setMenu( status: boolean ) {
        if ( status ) {
            this.opened = true;
            this.menuButtonText = 'de.his.portal.naviausblenden';
        } else {
            this.opened = false;
            this.menuButtonText = 'de.his.portal.navieinblenden';
        }
    }

    // fix for treeTables in p-dialog #312308
    isTreeTabelTogglerInDialog( clickedElement: HTMLElement ) {
        const curElement: HTMLElement | null = clickedElement;
        if ( !curElement || !curElement.parentElement ) return false;
        
        const treetabletogglerElement = curElement.parentElement;
        return !!( curElement &&
            curElement.classList.contains( 'p-treetable-toggler' ) &&
            treetabletogglerElement &&
            treetabletogglerElement.tagName === 'P-TREETABLETOGGLER' &&
            treetabletogglerElement.parentElement &&
            treetabletogglerElement.parentElement.classList.contains( 'treeTableTogglerContainer--inDialog' ) );

    }

    // fix for treeTables in p-dialog #312308
    rebindListenersInDialog() {
        const dialog = document.querySelector( '.p-dialog-content' );
        if ( !dialog ) return;
        let all = dialog.querySelectorAll( 'button, a:not(.p-tabview-nav-link, .p-menuitem-link), inlineicon:not(a *), .textTooltip, span[title], p-sorticon[title], p-treetablesorticon[title]' );
        all.forEach( ( element ) => {
            if ( element.getAttribute( 'focusTitle' ) !== 'true' ) {
                element.addEventListener( 'keyup', this.onKeyup.bind( this ) );
                element.addEventListener( 'focusout', this.onFocusout.bind( this ) );
                element.addEventListener( 'focus', this.onFocus.bind( this ) );
                element.addEventListener( 'mouseenter', this.onMouseenter.bind( this ) );
                element.addEventListener( 'mouseleave', this.onMouseleave.bind( this ) );
                element.addEventListener( 'click', this.onClickElement.bind( this ) );
            }
            element.setAttribute( 'focusTitle', 'true' );
        } );
    }
}
